import {debouncer, slideDown, slideUp} from '../utility/utils';
import Dom from '../utility/dom';
import Modal from './accessibility';
import {smoother} from "../utility/gsap";

export const initializeNav = (event) => {
  var container, button, menu, links, i, len;

	container = document.getElementById( 'site-navigation' );
	if ( ! container ) {
		return;
	}

	button = container.getElementsByTagName( 'button' )[0];
	if ( 'undefined' === typeof button ) {
		return;
	}

	menu = container.getElementsByTagName( 'ul' )[0];

	// Hide menu toggle button if menu is empty and return early.
	if ( 'undefined' === typeof menu ) {
		button.style.display = 'none';
		return;
	}

	menu.setAttribute( 'aria-expanded', 'false' );
	if ( -1 === menu.className.indexOf( 'nav-menu' ) ) {
		menu.className += ' nav-menu';
	}

	// Get all the link elements within the menu.
	links    = menu.getElementsByTagName( 'a' );

	// Each time a menu link is focused or blurred, toggle focus.
	for ( i = 0, len = links.length; i < len; i++ ) {
		links[i].addEventListener( 'focus', toggleFocus, true );
		links[i].addEventListener( 'blur', toggleFocus, true );
	}

	/**
	 * Sets or removes .focus class on an element.
	 */
	function toggleFocus() {
		var self = this;

		// Move up through the ancestors of the current link until we hit .nav-menu.
		while ( -1 === self.className.indexOf( 'nav-menu' ) ) {

			// On li elements toggle the class .focus.
			if ( 'li' === self.tagName.toLowerCase() ) {
				if ( -1 !== self.className.indexOf( 'focus' ) ) {
					self.className = self.className.replace( ' focus', '' );
				} else {
					self.className += ' focus';
				}
			}

			self = self.parentElement;
		}
	}

	var masthead = document.getElementById('masthead');
	var html = document.documentElement;
	var searchToggle = masthead ? masthead.querySelector('.searchToggle') : null;
	var headerFormWrap = document.querySelector('.headerFormWrap');
	var searchField = headerFormWrap ? headerFormWrap.querySelector('input.search-field') : null;
	var mainNavigation = document.querySelector('.main-navigation');
	var menuContainer = mainNavigation ? mainNavigation.querySelector('.menu-main-navigation-container') : null;
	var socialList = masthead ? masthead.querySelector('.socialList') : null;
	var mastheadContent = masthead ? masthead.querySelector('.content') : null;
	var searchWrap = masthead ? masthead.querySelector('.searchWrap') : null;
	var topContainer = masthead ? masthead.querySelector('.top .container') : null;
	var blurEvents = ['mouseup', 'mouseleave', 'click', 'mousedown'];

	function moveElement(element, target) {
		if ( element && target && element.parentElement !== target ) {
			target.appendChild(element);
		}
	}

	function toggleIcons(toggleButton) {
		if ( ! toggleButton ) {
			return;
		}

		var icons = toggleButton.querySelectorAll('i');
		icons.forEach(function(icon) {
			icon.style.display = window.getComputedStyle(icon).display === 'none' ? 'block' : 'none';
		});
	}

	function closeSubMenus(activeSubMenu) {
		var subMenus = menu.querySelectorAll('.sub-menu');

		subMenus.forEach(function(subMenu) {
			if ( subMenu !== activeSubMenu && window.getComputedStyle(subMenu).display !== 'none' ) {
				slideUp(subMenu);
			}
		});
	}

	button.addEventListener('click', function() {
		var isOpen = container.classList.toggle('toggled');

		button.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		menu.setAttribute( 'aria-expanded', isOpen ? 'true' : 'false' );
		toggleIcons(button);

		if ( isOpen ) {
			var scrollPosition = [
				window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
				window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop,
			];

			html.dataset.scrollX = String(scrollPosition[0]);
			html.dataset.scrollY = String(scrollPosition[1]);
			html.dataset.previousOverflow = window.getComputedStyle(html).overflow;
			html.style.overflow = 'hidden';
			window.scrollTo(scrollPosition[0], scrollPosition[1]);
			return;
		}

		html.style.overflow = html.dataset.previousOverflow || '';
		window.scrollTo(Number(html.dataset.scrollX || 0), Number(html.dataset.scrollY || 0));
		closeSubMenus();
		if ( masthead ) {
			masthead.querySelectorAll('.focus').forEach(function(element) {
				element.classList.remove('focus');
			});
		}
	});

	// Remove focus on clicked links
	blurEvents.forEach(function(eventName) {
		document.body.addEventListener(eventName, function(e) {
			if ( ! (e.target instanceof Element) ) {
				return;
			}

			var interactiveElement = e.target.closest('a, button');
			if ( interactiveElement ) {
				interactiveElement.blur();
			}
		});
	});

	if ( searchToggle ) {
		searchToggle.addEventListener('click', function(e) {
			e.preventDefault();
			toggleIcons(searchToggle);

			var isSearchActive = masthead.classList.toggle('searchActive');
			if ( headerFormWrap ) {
				headerFormWrap.style.display = isSearchActive ? 'block' : 'none';
			}

			if ( isSearchActive && searchField ) {
				searchField.focus();
			}
		});
	}

	// Toggle Focus
	var mobileNav = function() {
		var windowWidth = window.innerWidth;

		if(windowWidth < 1201){
			if(mainNavigation && !mainNavigation.classList.contains('mobile')){
				mainNavigation.classList.add('mobile');
				moveElement(socialList, menuContainer);
			}
		} else {
			if(mainNavigation && mainNavigation.classList.contains('mobile')){
				mainNavigation.classList.remove('mobile');
				mainNavigation.querySelectorAll('.sub-menu').forEach(function(subMenu) {
					subMenu.style.display = '';
				});
				moveElement(socialList, mastheadContent);
			}

			if ( mainNavigation ) {
				mainNavigation.querySelectorAll('li.focus').forEach(function(item) {
					item.classList.remove('focus');
				});
			}
		}

		if(windowWidth <= 650) {
			moveElement(searchWrap, menuContainer);
		} else {
			moveElement(searchWrap, topContainer);
		}
	};

	document.body.addEventListener('click', function(e) {
		if ( ! (e.target instanceof Element) ) {
			return;
		}

		var toggleLink = e.target.closest('.nav-menu li.menu-item-has-children > a');
		if ( ! toggleLink || window.innerWidth >= 1201 ) {
			return;
		}

		var parent = toggleLink.parentElement;
		var subMenu = toggleLink.nextElementSibling;

		if ( ! parent || ! subMenu || ! subMenu.classList.contains('sub-menu') ) {
			return;
		}

		if ( parent.classList.contains('focus') ) {
			return;
		}

		e.preventDefault();
		slideDown(subMenu);
		closeSubMenus(subMenu);
		menu.querySelectorAll('li.focus').forEach(function(item) {
			if ( item !== parent ) {
				item.classList.remove('focus');
			}
		});
		parent.classList.add('focus');
	});

	mobileNav();
	window.addEventListener('resize', debouncer(mobileNav, 50));

	// Animated Header
	var animatedHeader = function() {
		if ( ! masthead ) {
			return;
		}

		if ( window.scrollY > 100 ) {
			masthead.classList.add('scrolledHeader');
		} else {
			masthead.classList.remove('scrolledHeader');
		}
	};
	animatedHeader();

	// Scroll to Fix
	var scrollToFixElements = document.querySelectorAll('.scrolltofix');

	function getPlaceholder(element) {
		var previousSibling = element.previousElementSibling;
		return previousSibling && previousSibling.classList.contains('placeholder') ? previousSibling : null;
	}

	var scrollToFixInitialize = function() {
		scrollToFixElements.forEach(function(element) {
			element.classList.remove('fixed');
			element.style.top = '';
			element.style.position = '';

			var placeholder = getPlaceholder(element);
			if ( placeholder ) {
				placeholder.style.display = 'none';
			}

			var height = Math.round(element.getBoundingClientRect().height);
			var originalPosition = Math.round(element.getBoundingClientRect().top + window.scrollY);
			var cssTop = parseInt(window.getComputedStyle(element).top, 10);
			var safeCssTop = Number.isNaN(cssTop) ? 0 : cssTop;

			element.dataset.cssTop = String(safeCssTop);
			element.dataset.originalPos = String(originalPosition);

			if ( ! placeholder ) {
				placeholder = document.createElement('span');
				placeholder.className = 'placeholder';
				placeholder.style.display = 'none';
				placeholder.style.position = 'relative';
				element.parentNode.insertBefore(placeholder, element);
			}

			placeholder.style.height = height + 'px';
			placeholder.style.top = safeCssTop + 'px';
		});
	};
	scrollToFixInitialize();

	var scrollToFix = function() {
		scrollToFixElements.forEach(function(element) {
			var originalPosition = Number(element.dataset.originalPos || 0);
			var cssTop = Number(element.dataset.cssTop || 0);
			var triggerTop = window.scrollY + cssTop;
			var elementHeight = Math.round(element.getBoundingClientRect().height);
			var placeholder = getPlaceholder(element);

			if ( placeholder ) {
				placeholder.style.height = elementHeight + 'px';
			}

			if ( triggerTop <= originalPosition ) {
				element.classList.add('topLimit');
				element.classList.remove('fixed');
				element.style.position = '';
				if ( placeholder ) {
					placeholder.style.display = 'none';
				}
			} else {
				element.classList.add('fixed');
				element.classList.remove('unfixed');
				element.style.position = 'fixed';
				element.style.top = '0';
				if ( placeholder ) {
					placeholder.style.display = 'block';
				}
			}
		});
	};
	scrollToFix();

	window.addEventListener('scroll', function() {
		animatedHeader();
		scrollToFix();
	}, {passive: true});

	window.addEventListener('resize', debouncer(function() {
		scrollToFixInitialize();
		scrollToFix();
		animatedHeader();
	}, 50));
};
